// extracted by mini-css-extract-plugin
module.exports = {"email":"MigrateStaffAccountVerify_email__BE_mX","cta":"MigrateStaffAccountVerify_cta__35yMK"};